import { fetchMediaUploadPermission } from '@atlassian/jira-issue-fetch-services/src/services/issue-media-upload-permissions/index.tsx';
import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';

export const getMediaUploadConfig = (issueKey: IssueKey) =>
	fetchMediaUploadPermission('', issueKey);
